import React from "react";
import {
  DINE_IN_LEGEND_STATES,
  DINE_IN_TABLE_STATE_META,
} from "./dineInBoardStatusDefs";
import "./styles/DineInBoardStates.css";
import "./styles/DineInBoardLegend.css";

/** Colour key for the grid. Static — it explains the tiles, it doesn't filter them. */
const DineInBoardLegend: React.FC = () => (
  <div className="dine-in-legend">
    {DINE_IN_LEGEND_STATES.map((state) => {
      const meta = DINE_IN_TABLE_STATE_META[state];
      return (
        <span key={state} className={`dine-in-legend__item dine-in-state--${meta.modifier}`}>
          <span className="dine-in-legend__dot" aria-hidden="true" />
          {meta.label}
        </span>
      );
    })}
  </div>
);

export default DineInBoardLegend;
